import { Button, ButtonGroup } from "@mui/material";
import { useEffect, useState } from "react";
import "./QuantityPicker.scss";

export const QuantityPicker = ({ maxCount, onQuantityChange, quantity = 1, disabled = false, }) => {
    const [counter, setCounter] = useState(quantity);
    const increment = () => {
        if (onQuantityChange) {
            onQuantityChange(quantity + 1);
        } else {
            setCounter(counter + 1);
        }
    }
    const decrement = () => {
        if (onQuantityChange) {
            onQuantityChange(quantity - 1);
        } else {
            setCounter(counter - 1);
        }
    }

    return (
        <ButtonGroup size="small" aria-label="small outlined button group" className="quantity-picker">
            {(quantity > 0 || (quantity === undefined && counter > 0)) && <Button onClick={decrement}>-</Button>}
            <input value={quantity !== undefined ? quantity : counter} readOnly></input>
            {!disabled && !(maxCount && (quantity === maxCount || (quantity === undefined && counter === maxCount))) && <Button onClick={increment}>+</Button>}
        </ButtonGroup>
    );
}